import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClinicMerchantAccountSettings } from '@models/payments/clinic-merchant-account-settings';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClinicMerchantAccountSettingsService {
  constructor(private http: HttpClient) {}

  addClinicMerchantAccountSettings(clinicMerchantAccountSettings: ClinicMerchantAccountSettings) {
    return this.http.post<ClinicMerchantAccountSettings>(
      environment.baseUrl + 'api/ClinicMerchantAccountSettings',
      clinicMerchantAccountSettings
    );
  }

  updateClinicMerchantAccountSettings(clinicMerchantAccountSettings: ClinicMerchantAccountSettings) {
    return this.http.put<ClinicMerchantAccountSettings>(
      environment.baseUrl + 'api/ClinicMerchantAccountSettings/' + clinicMerchantAccountSettings.id,
      clinicMerchantAccountSettings
    );
  }

  getClinicMerchantAccountSettings() {
    return this.http.get<ClinicMerchantAccountSettings>(environment.baseUrl + 'api/ClinicMerchantAccountSettings');
  }

  deleteClinicMerchantAccountSettings(clinicMerchantAccountSettingsId: number) {
    return this.http.delete<ClinicMerchantAccountSettings>(
      `${environment.baseUrl}api/ClinicMerchantAccountSettings/${clinicMerchantAccountSettingsId}`
    );
  }
}
